import Icon, { IconProps } from './Icon';

import DOCXIcon from '../../../assets/icons/docx.svg?react';

const DOCX: React.FC<Omit<IconProps, 'children'>> = (props) => {
    return (
        <Icon {...props}>
            <DOCXIcon />
        </Icon>
    );
};

export default DOCX;




